import React from 'react';
import { FaRuler, FaCheckCircle } from 'react-icons/fa';

const FrameSize = () => {
  return (
    <div className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Frame <span className="text-orange-500">Size Guide</span></h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <FaRuler className="text-4xl text-orange-500" />
            <h2 className="text-2xl font-semibold text-gray-800">How to Measure</h2>
          </div>
          <p className="text-gray-600 mb-4">Look inside your current glasses – you'll see three numbers (e.g., 52-18-140).</p>
          <ul className="space-y-3">
            <li className="flex items-start gap-2">
              <FaCheckCircle className="text-green-500 mt-1" />
              <span><strong>Lens Width</strong> (first number) – width of one lens</span>
            </li>
            <li className="flex items-start gap-2">
              <FaCheckCircle className="text-green-500 mt-1" />
              <span><strong>Bridge Width</strong> (second number) – distance between lenses</span>
            </li>
            <li className="flex items-start gap-2">
              <FaCheckCircle className="text-green-500 mt-1" />
              <span><strong>Temple Length</strong> (third number) – length of the arm</span>
            </li>
          </ul>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-3">Small</h3>
            <p className="text-gray-600">Lens: 48-52mm | Bridge: 16-18mm | Temple: 135-140mm</p>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-3">Medium</h3>
            <p className="text-gray-600">Lens: 52-55mm | Bridge: 18-20mm | Temple: 140-145mm</p>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-3">Large</h3>
            <p className="text-gray-600">Lens: 55-58mm | Bridge: 20-22mm | Temple: 145-150mm</p>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-3">Extra Large</h3>
            <p className="text-gray-600">Lens: 58mm+ | Bridge: 22mm+ | Temple: 150mm+</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrameSize;